import { ADD_VITALS, UNSET_VITALS_BY_TYPE_REDUCER } from "containers/Profile/services/constants"
import { HYDRATE_VITALS, RESET_VITALS, SET_CHECKUP_VITALS, SET_VITALS_STEP } from "./constants"
import { CALL_HANGUP_SUCCESS } from "containers/Call/services/constants"
import { RESET_SURVEY_STORE } from "containers/Survey/services/constants"
import { VitalsStore } from "types/store"

export const initialState: Partial<VitalsStore> = {}

const reducer = function vitalsReducer(
  state = initialState,
  action: { type: string, payload: any, patient_id: number }
): Partial<VitalsStore> {
  const newState = { ...state }
  switch (action.type) {
    case ADD_VITALS: {
      return {
        ...newState,
        [action.patient_id]: {
          ...newState[action.patient_id],
          [action.payload.type]: {
            value: action.payload.value,
            id: action.payload.id,
          }
        }
      }
    }
    case HYDRATE_VITALS: {
      return {
        ...newState,
        ...action.payload,
      }
    }
    case SET_VITALS_STEP: {
      if (action.payload === undefined) {
        delete newState.currentStep
        return newState
      }
      return {
        ...newState,
        currentStep: action.payload,
      }
    }
    case RESET_VITALS: {
      return {}
    }
    case SET_CHECKUP_VITALS: {
      return {
        ...newState,
        checkupVitals: action.payload,
      }
    }
    // The check-up vitals only apply to the teleconsultation launched from
    // the check-up end screen: forget them once it ends or when a new
    // pathway starts (the end screen resets the survey before setting them)
    case CALL_HANGUP_SUCCESS:
    case RESET_SURVEY_STORE: {
      delete newState.checkupVitals
      return newState
    }
    case UNSET_VITALS_BY_TYPE_REDUCER: {
      if(newState[action?.payload?.patient_id]?.[action?.payload?.type]) {
        delete newState[action.payload?.patient_id][action.payload?.type];
      }
      return newState;
    }
    default:
      return newState
  }
}

export default reducer
